<div class="container cpal">
    <div class="row">
        <h2>Formulario Estado Situación</h2>
      </div>
<mat-stepper orientation="vertical" [linear]="false" #stepper>
    <mat-step label="IdentificacionCliente">
        <ng-template matStepLabel>Identificación Cliente</ng-template>
        <app-identificacion-cliente></app-identificacion-cliente>
    </mat-step>
    <mat-step label="DireccionParticular">
        <ng-template matStepLabel>Dirección Particular</ng-template>
        <app-direccion-particular></app-direccion-particular>
    </mat-step>
    <mat-step label="DirecionComercial">
        <ng-template matStepLabel>Dirección Comercial</ng-template>
        <app-direccion-comercial></app-direccion-comercial>
    </mat-step>
    <mat-step label="AntecedentesOcupaciones">
        <ng-template matStepLabel>Antecedentes Ocupacionales</ng-template>
        <app-antecedentes-ocupacionales></app-antecedentes-ocupacionales>
    </mat-step>
    <mat-step label="AntecedentesConviviente">
        <ng-template matStepLabel>Antecedentes Conviviente</ng-template>
        <app-antecedentes-conviviente></app-antecedentes-conviviente>
    </mat-step>
    <mat-step label="Activos">
        <ng-template matStepLabel>Activos</ng-template>
        <app-activos></app-activos>
    </mat-step>
    <mat-step label="ParticipacionSociedades">
        <ng-template matStepLabel>Participación Sociedades</ng-template>
        <app-participacion-sociedades></app-participacion-sociedades>
    </mat-step>
    <mat-step label="Pasivos">
        <ng-template matStepLabel>Pasivos</ng-template>
        <app-pasivos></app-pasivos>
    </mat-step>
    <mat-step label="Documentos">
        <ng-template matStepLabel>Documentos</ng-template>
        <app-documentos-adjuntos></app-documentos-adjuntos>
    </mat-step>
    <mat-step label="Resumen">
        <ng-template matStepLabel>Resumen</ng-template>
        <app-resumen></app-resumen>
    </mat-step>
</mat-stepper>
</div>